import type { HarmonyPackageBoard } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { eq, useLiveQuery } from '@tanstack/vue-db'

import { HARMONY_PACKAGE_BOARD_TABLE } from '../collections'
import { useCollection } from '../composables/useCollection'

export function useBoardById(boardId: string, packageId: string): UseLiveQueryReturn<HarmonyPackageBoard> | undefined {
  if (!boardId || !packageId) return undefined

  const boards = useCollection<HarmonyPackageBoard>(HARMONY_PACKAGE_BOARD_TABLE, {
    package_id: packageId,
  }).collection

  const query = useLiveQuery((builder) => builder.from({ board: boards }).where(({ board }) => eq(board.id, boardId)))

  return query
}
